// extracted by mini-css-extract-plugin
module.exports = {"connectionGroupTitle":"_1B3496pJ","connectionGroup":"LSKkj6hG"};